import { __t } from '@/lib/helpers'

export const READERS = {
  BBPOS_WISEPOS_E: {
    device_type: 'bbpos_wisepos_e',
    product_type: 'bbpos_wisepos_e',
    name: 'BBPOS WisePOS™ E',
    wifi: true,
    bluetooth: false,
    disabled: false,
  },
  STRIPE_S710: {
    device_type: 'stripe_s710',
    product_type: 'stripe_s710',
    name: __t('payments.booksy_card_reader.reader.stripe_reader_s.name'),
    wifi: true,
    bluetooth: false,
    disabled: false,
  },
  STRIPE_M2: {
    device_type: 'stripe_m2',
    product_type: 'stripe_m2',
    name: 'Stripe Reader M2',
    wifi: false,
    bluetooth: true,
    disabled: false,
  },
  BBPOS_CHIPPER_2X: {
    device_type: 'bbpos_chipper2x',
    product_type: 'bbpos_chipper_2x',
    name: 'BBPOS Chipper 2X',
    wifi: false,
    bluetooth: true,
    disabled: true,
  },
}

export const ONBOARDING_STATUSES = {
  TERMINAL_ORDERED: 'TERMINAL_ORDERED',
  TERMINAL_SHIPPED: 'TERMINAL_SHIPPED',
  FIRST_SUCCEEDED_TRANSACTION: 'FIRST_SUCCEEDED_TRANSACTION',
}

export const CONNECTIONS_STATUSES = {
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  NOT_CONNECTED: 'not_connected',
}

export const READER_STATUSES = {
  ONLINE: 'online',
  BUSY: 'busy',
  OFFLINE: 'offline',
}

// https://stripe.com/docs/api/terminal/readers/object
export const READER_ACTION_STATUSES = {
  IN_PROGRESS: 'in_progress',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
}

export const PERMISSIONS = {
  BLUETOOTH: 'bluetooth',
  LOCATION: 'location',
}

export const CONNECT_STEPS_ICONS = {
  CLOSE: {
    height: '32px',
    name: 'x',
  },
  GO_BACK: {
    height: '20px',
    name: 'nav-arrow-left',
  },
}

export const FAST_PAYOUTS_ADMIN_BLOCKED = {
  TRUE: true,
  FALSE: false,
}

export const FAST_PAYOUTS_VISIBLE = {
  TRUE: true,
  FALSE: false,
}

export const FAST_PAYOUTS_AVAILABLE = {
  TRUE: true,
  FALSE: false,
}

export const FAST_PAYOUTS_AVAILABLE_TODAY = {
  TRUE: true,
  FALSE: false,
}

export const STRIPE_KYC_MERCHANT_PAYMENT_METHOD = {
  BANK_ACCOUNT: 'bank_account',
  DEBIT_CARD: 'debit_card',
}

export const PAYOUT_METHOD = {
  FAST: 'fast',
  STANDARD: 'standard',
}

export const AGREEMENTS_LINK = 'https://stripe.com/connect-account/legal'

export const HELP_LINKS = {
  CONNECT: 'https://booksy.com/biz/en-us/faq#how-can-i-troubleshoot-connecting-my-bbpos-wisepos-e',
  DNS: 'https://booksy.com/biz/en-us/faq#if-my-device-still-doesn-t-connect-after-troubleshooting-what-can-i-do',
}

export const INTEGRATION_MODES = {
  SDK: 'SDK',
  SDI: 'SDI',
}

export const BCR_ACTIONS = {
  CANCEL: 'cancel',
}

export const LOCAL_STORAGE_LAST_READER_SN = 'bcr_last_reader_sn'

export const VIEWS_DIRECTIONS = {
  NEXT: 'next',
  PREVIOUS: 'previous',
}
export const TEST_CARDS_NUMBERS = [
  { label: 'Visa', payment_method: 'visa', value: '4242424242424242' },
  { label: 'Visa (debit)', payment_method: 'visa_debit', value: '4000056655665556' },
  { label: 'Mastercard', payment_method: 'mastercard', value: '5555555555554444' },
  { label: 'Mastercard (debit)', payment_method: 'mastercard_debit', value: '5200828282828210' },
  { label: 'Mastercard (prepaid)', payment_method: 'mastercard_prepaid', value: '5105105105105100' },
  { label: 'American Express', payment_method: 'amex', value: '378282246310005' },
  { label: 'American Express 2', payment_method: 'amex2', value: '371449635398431' },
  { label: 'Discover', payment_method: 'discover', value: '6011111111111117' },
  { label: 'Discover 2', payment_method: 'discover2', value: '6011000990139424' },
  { label: 'Diners club', payment_method: 'diners', value: '3056930009020004' },
  { label: 'Diners Club (14 digit card)', payment_method: 'diners_14digits', value: '36227206271667' },
  { label: 'JCB', payment_method: 'jcb', value: '3566002020360505' },
  { label: 'UnionPay', payment_method: 'unionpay', value: '6200000000000005' },
  { label: 'Interac', payment_method: 'interac', value: '4506445006931933' },
  { label: 'Success: Offline Pin Setting', payment_method: 'offline_pin_cvm', value: '4001007020000002' },
  { label: 'Success: Offline Pin Retry', payment_method: 'offline_pin_sca_retry', value: '4000008260000075' },
  { label: 'Success: Online Pin Setting', payment_method: 'online_pin_cvm', value: '4001000360000005' },
  { label: 'Success: Online Pin Retry', payment_method: 'online_pin_sca_retr', value: '4000002760000008' },
  { label: 'Error declined: Card Declined', payment_method: 'charge_declined', value: '4000000000000002' },
  { label: 'Error declined: Insufficient funds', payment_method: 'charge_declined_insufficient_funds', value: '4000000000009995' },
  { label: 'Error declined: Lost Card', payment_method: 'charge_declined_lost_card', value: '4000000000009987' },
  { label: 'Error declined: Stolen Card', payment_method: 'charge_declined_stolen_card', value: '4000000000009979' },
  { label: 'Error declined: Expired Card', payment_method: 'charge_declined_expired_card', value: '4000000000000069' },
  { label: 'Error declined: Processing Error', payment_method: 'charge_declined_processing_error', value: '4000000000000119' },
  { label: 'Error: Refund fail', payment_method: 'refund_fail', value: '4000000000005126' },
  { label: 'Error Incorrect number', payment_method: 'incorrect_number', value: '4242424242424241' },
  { label: 'Chargeback: Fraudulent', payment_method: 'pm_card_createDispute', value: '4000000000000259' },
  { label: 'Chargeback: Not received', payment_method: 'm_card_createDisputeProductNotReceived', value: '4000000000002685' },
  { label: 'Chargeback: Inquiry', payment_method: 'pm_card_createDisputeInquiry', value: '4000000000001976' },
  { label: 'Chargeback: Warning', value: '4000000000005423' },
  { label: 'Country Americas: Brazil', payment_method: 'pm_card_br', value: '4000000760000002' },
  { label: 'Counry Americas: Canada', payment_method: 'pm_card_ca', value: '4000001240000000' },
  { label: 'Country Americas: Mexico', payment_method: 'pm_card_mx', value: '4000004840008001' },
  { label: 'Country Europe: France', payment_method: 'pm_card_fr', value: '4000002500000003' },
  { label: 'Country Europe: Poland', payment_method: 'pm_card_pl', value: '4000006160000005' },
  { label: 'Country Eruope: Portugal', payment_method: 'pm_card_pt', value: '4000006200000007' },
  { label: 'Country Europe: Spain', payment_method: 'pm_card_es', value: '4000007240000007' },
  { label: 'Country Europe: United Kingdom', payment_method: 'pm_card_gb', value: '4000008260000000' },
  { label: 'Fraud prevention: Always blocked', payment_method: 'pm_card_radarBlock', value: '4100000000000019' },
  { label: 'Fraud prevention: Highest risk', payment_method: 'pm_card_riskLevelHighest', value: '4000000000004954' },
  { label: 'Fraud prevention: Elevated risk', payment_method: 'pm_card_riskLevelElevated', value: '4000000000009235' },
  { label: 'Refunds: Asynchronous success', payment_method: 'pm_card_pendingRefund', value: '4000000000007726' },
  { label: 'Refunds: Asynchronous failure', payment_method: 'pm_card_refundFail', value: '4000000000005126' },
  { label: 'Available balance: Bypass pending balance', payment_method: 'pm_card_bypassPending', value: '4000000000000077' },
  { label: 'Available balance: Bypass pending balance - international', payment_method: 'pm_card_bypassPendingInternational', value: '4000003720000278' },
]

export const EVENTS_SCREENS = {
  READERS_LIST: 'readers_list',
  LEARN_MORE: 'learn_more',
}

export const EVENTS_ACTION_NAME = {
  READER_TO_LONG_BUSY: 'reader_too_long_busy',
}
